import FlagUK from '~/assets/svgs/flag-uk.svg?react'
import FlagUS from '~/assets/svgs/flag-us.svg?react'
import { i18nConfig } from '~/i18nInstance'
import { Environment } from '~/types/EnvironmentTypes'

export interface RegionConfig {
  environment: Environment
  flag: string
  FlagIcon: SVGComponent
  abbreviation: string
  fullName: string
  getLocalizedName: () => string
}

export const REGIONS: Record<Environment, RegionConfig> = {
  [Environment.PRODUCTION]: {
    environment: Environment.PRODUCTION,
    flag: 'US',
    FlagIcon: FlagUS,
    abbreviation: 'US',
    fullName: 'United States',
    getLocalizedName: () => i18nConfig.t('regionSelector.regions.unitedStates'),
  },
  [Environment.PRODUCTION_UK]: {
    environment: Environment.PRODUCTION_UK,
    flag: 'UK',
    FlagIcon: FlagUK,
    abbreviation: 'UK',
    fullName: 'United Kingdom',
    getLocalizedName: () =>
      i18nConfig.t('regionSelector.regions.unitedKingdom'),
  },
  [Environment.STAGING]: {
    environment: Environment.STAGING,
    flag: 'US',
    FlagIcon: FlagUS,
    abbreviation: 'US',
    fullName: 'United States',
    getLocalizedName: () => i18nConfig.t('regionSelector.regions.unitedStates'),
  },
  [Environment.LOCAL]: {
    environment: Environment.LOCAL,
    flag: 'US',
    FlagIcon: FlagUS,
    abbreviation: 'US',
    fullName: 'United States',
    getLocalizedName: () => i18nConfig.t('regionSelector.regions.unitedStates'),
  },
  [Environment.DEVELOPMENT]: {
    environment: Environment.DEVELOPMENT,
    flag: 'US',
    FlagIcon: FlagUS,
    abbreviation: 'US',
    fullName: 'United States',
    getLocalizedName: () => i18nConfig.t('regionSelector.regions.unitedStates'),
  },
}

export const getRegionConfig = (environment: Environment): RegionConfig => {
  return REGIONS[environment] || REGIONS[Environment.PRODUCTION]
}
